import { IconButton, Menu } from '@zillow/constellation-10';
import { IconMoreFilled } from '@zillow/constellation-icons';

type Props = {
  fileName?: string | null;
  removeLabel?: string;
  onRemove?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
};

export function DocumentCardMenu({ fileName, removeLabel, onRemove, onDelete, disabled }: Props) {
  return (
    <Menu
      trigger={
        <IconButton
          icon={<IconMoreFilled />}
          type="button"
          emphasis="bare"
          size="xs"
          title={`Actions for ${fileName || 'income document'}`}
          disabled={disabled}
        />
      }
      content={
        <>
          {onRemove && removeLabel && (
            <Menu.Item onClick={onRemove}>
              <Menu.ItemLabel>{removeLabel}</Menu.ItemLabel>
            </Menu.Item>
          )}
          {onDelete && (
            <Menu.Item onClick={onDelete}>
              <Menu.ItemLabel>Delete</Menu.ItemLabel>
            </Menu.Item>
          )}
        </>
      }
    />
  );
}
